import { ReactNode } from 'react';

import { cx } from '@libs/classnames';

import styles from './Form.module.css';

export type Props = {
  className?: string;
  preset?: 'default' | 'results';
  indented?: boolean;
  children: ReactNode;
};

export function Form({ className, children, indented, preset = 'default' }: Props) {
  return (
    <div
      className={cx(className, styles.form, {
        [styles.preset_results]: preset === 'results',
        [styles.indented]: indented,
      })}
    >
      {children}
    </div>
  );
}

//

type FormRowProps = {
  className?: string;
  children: ReactNode;
};
export function FormRow({ className, children }: FormRowProps) {
  return <div className={cx(className, styles.formRow)}>{children}</div>;
}

//

type FormRowLabelProps = {
  className?: string;
  children: ReactNode;
};
export function FormRowLabel({ className, children }: FormRowLabelProps) {
  return (
    <div className={className}>
      <div className={styles.formRowLabelInner}>{children}</div>
    </div>
  );
}

//

type FormLabelProps = {
  className?: string;
  indented?: boolean;
  hint?: ReactNode;
  children?: ReactNode;
};
export function FormLabel({ className, indented, hint, children }: FormLabelProps) {
  return (
    <div
      className={cx(className, styles.formLabel, {
        [styles.indented]: indented,
      })}
    >
      {children}
      {hint && (
        <>
          <br />
          <span className={styles.hint}>{hint}</span>
        </>
      )}
    </div>
  );
}

//

type FormInputProps = {
  className?: string;
  children: ReactNode;
};
export function FormInput({ className, children }: FormInputProps) {
  return <div className={cx(className, styles.formInput)}>{children}</div>;
}

//

type FormErrorProps = {
  className?: string;
  children: ReactNode;
}
export function FormError({ className, children }: FormErrorProps) {
  return <div className={cx(className, styles.formError)}>{children}</div>;
}
